// extracted by mini-css-extract-plugin
module.exports = {"board_second_wrapper":"BoardSecond_board_second_wrapper__2tYbn"};